<template>
    <div class="Nav">
        <van-nav-bar :title="msg" :placeholder="true" :fixed="true" class="nav_box"
            @click-left="onClickLeft"
            @click-right="onClickRight">
            <template #left>
                <img src="../assets/img/BDM.png" class="nav_img" alt="乒乓球">
            </template>
            <template #right>
                <i v-if="IsHome" class="el-icon-s-unfold icon_font"></i>
            </template>
        </van-nav-bar>

        <van-popup v-model="show"
         position="right" 
            :style="{ 'width': '32%','height':'100%','background':'#3277BC' }"
            closeable 
            :close-on-popstate="true"
          >
            <ul class="nav_list">
                <li v-for="(i,index) in NaList.nav" :key="index"
                 @click="handleNav(i,index)"
                 :class="{'active' : i.Route_Name === $route.name}"
                 >{{$i18n.locale == 'ENG'? i.ENG_Name : i.CHN_Name}}</li>
            </ul>
        </van-popup>

    </div>
</template>



<script>
import NaList from '@/assets/common/nav.json';
export default {
    name:'mNav',
    props: {
        msg: String,
        IsHome: Boolean,
    },
    data() {
        return {
            show: false,
            NaList: NaList,
            isActive: 0,
        }
    },
    mounted() {
        // console.log(this.NaList)
        // this.isActive = this.NaList.nav;
        // console.log(this.$route)
    },
    methods: {
        onClickRight(){//点击右上角按钮
            this.show = true;
        },
        onClickLeft(){//点击导航左侧按钮
            let randomNum = Math.random(); // 这里的范围根据需求进行调整
            // this.$router.push('/mHome');
            this.$router.push({
                path: '/mHome', 
                query: { v: randomNum }
            });
        },
        handleNav(i,index){//点击导航
            // console.log(i)
            this.isActive = index;
            console.log(index)
            // console.log(this.$route);
            // 生成随机数
            let randomNum = Math.random(); // 这里的范围根据需求进行调整
            
            switch (i.CHN_Name) {
                // case '实时成绩':
                //     if(this.$route.name == 'Live'){
                //         return false;
                //     }else{
                //         this.$router.push({
                //             path: '/Live', 
                //             query: { v: randomNum }
                //         });
                //     }
                //     break;
                case '赛事成绩':
                    if(this.$route.name == 'GameResult'){
                        return false;
                    }else{
                        // this.$router.push('/GameResult');
                        this.$router.push({
                            path: '/GameResult', 
                            query: { v: randomNum }
                        });
                        
                    }
                    break;
                case '循环赛':
                    if(this.$route.name == 'Pool'){
                        return false;
                    }else{
                        // this.$router.push('/Pool');
                        this.$router.push({
                            path: '/Pool', 
                            query: { v: randomNum }
                        });
                    }
                    break;
                case '淘汰赛':
                    if(this.$route.name == 'Brackets'){
                        return false;
                    }else{
                        // this.$router.push('/Brackets');
                        this.$router.push({
                            path: '/Brackets', 
                            query: { v: randomNum }
                        });
                    }
                
                    break;
                case '排名奖牌':
                    if(this.$route.name == 'Rank'){
                        return false;
                    }else{
                        // this.$router.push('/Rank');
                        this.$router.push({
                            path: '/Rank', 
                            query: { v: randomNum }
                        });
                    }
                
                    break;
                case '文件列表':
                    if(this.$route.name == 'Files'){
                        return false;
                    }else{
                        // this.$router.push('/Rank');
                        this.$router.push({
                            path: '/Files', 
                            query: { v: randomNum }
                        });
                    }
                
                    break;
                default:
                    break;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    $bgColor: #3277BC;
    ::v-deep .van-nav-bar{
        background: $bgColor;
         .van-nav-bar__title{
            // font-size: 0.3rem;
            font-weight: bold;
            color: white;
        }
    }
    .nav_box{
        background: $bgColor;
        .icon_font{
            font-size: 0.5rem;
            color: white;
        }
    }
    .nav_img{
        // width: 0.46rem;
        height: 0.6rem;
    }
    .nav_list{
        padding: 0.8rem 0;
        font-size: 0.24rem;
        li{
            width: 100%;
            padding: 0.2rem;
            line-height: 0.4rem;
            color: white;
            border-bottom: 1px solid #666;
            font-weight: bold;
        }
    }
    .active{
        background: white;
        color: $bgColor !important;
    }
    .router-link-active{
        background: white;
        color: $bgColor !important;
    }
</style>